import { render, staticRenderFns } from "./CitasForm.vue?vue&type=template&id=d3f56b04"
import script from "./CitasForm.vue?vue&type=script&lang=js"
export * from "./CitasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports